module.exports = __webpack_public_path__ + "img/warn.5fc8a1cc.png";